// ─────────────────────────────────────────────────────────────────────────
//  ClickViewer · web · 화면 머리 (제목 + 부제 + 동작)
//
//  ★ 화면마다 제목을 따로 조립하지 마라. 크기가 갈리는 순간 위계가 무너진다 —
//    그리고 야외에서는 **크기가 위계의 거의 전부**다(theme.ts 제1원칙).
//
//  ★ `actions` 자리 규칙:
//      · **읽기 전용/보조 동작만** 여기 둔다(설정 열기, 도움말).
//      · 주동작·파괴적 동작은 폰에서 **화면 아래 1/3** 로 내려라 —
//        `<div className="cv-bottombar">` 를 화면 맨 끝에 두면 된다.
//        한 손에 도면이나 무전기를 든 사람은 화면 위쪽에 엄지가 안 닿는다.
// ─────────────────────────────────────────────────────────────────────────

import { Box, Group, Stack, Text, Title } from '@mantine/core';
import type { ReactNode } from 'react';

export function PageHeader({
  title,
  /**
   * 제목 밑 한 줄.
   *
   * ⚠️ **muted 로 그리지 않는다.** 여기에 들어오는 것은 대개 「3개」「/dangjin」처럼
   *    사람이 실제로 읽고 판단하는 **데이터**다. 야외에서 muted 는 2.86:1 이라 안 보인다.
   *    → --cv-ink-2 (14px 에서 3.21:1). muted 는 라벨 전용이다.
   */
  subtitle,
  actions,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <Group justify="space-between" align="flex-start" wrap="wrap" gap="sm">
      <Box style={{ minWidth: 0 }}>
        <Stack gap={4}>
          {/* order={1} = 28px. **화면당 한 번**만 쓴다(theme.ts fontSizes 주석). */}
          <Title order={1}>{title}</Title>
          {subtitle ? (
            <Text size="sm" c="var(--cv-ink-2)">
              {subtitle}
            </Text>
          ) : null}
        </Stack>
      </Box>
      {actions ? <div className="cv-touchrow">{actions}</div> : null}
    </Group>
  );
}

/**
 * 섹션 제목(20px). 한 화면 안에서 묶음을 나눌 때.
 * ⚠️ 이것보다 작은 제목을 새로 만들지 마라. 16px 아래는 제목이 아니라 라벨이다.
 */
export function SectionTitle({ children }: { children: ReactNode }) {
  return <Title order={2}>{children}</Title>;
}
